
<b-col cols="24">
  <OrderProductGrid
    key="products"
    :products="model.products"
    :loading="loading"
    :rotating-subscription="model.rotating_subscription"
  />
  <div v-if="loading" class="loading-container">
    <Spinner :size="100" centered />
  </div>
</b-col>
